import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import RaceTable from "./RaceTable";
import CssBaseline from "@material-ui/core/CssBaseline";
import Box from "@material-ui/core/Box";
import {Sponsors} from "./Sponsors";
import {IconButton} from "@material-ui/core";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (

                <div>{children}</div>

            )}
            <Sponsors size={"110px"}/>
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const RacesTabs = (props) => {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return(
        <Box>
            <CssBaseline />
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    <Tab label="2022_wintertrail" {...a11yProps(0)} />
                    <Tab label="2021 180k" {...a11yProps(1)} />
                    <Tab label="2021 100k" {...a11yProps(2)} />
                    <Tab label="2021 50k" {...a11yProps(3)} />
                    <Tab label="2020 180k" {...a11yProps(4)} />
                    <Tab label="2020 100k" {...a11yProps(5)} />
                    <Tab label="2020 40k" {...a11yProps(6)} />
                </Tabs>
                <IconButton style={{display:'inline',position:'absolute',top:'9px',right:'10px',zIndex:'12'}}>
                    <a href={"http://apuseniultrarace.ro/"}><img alt={"logo"} src={require('../assets/logo.png')}/></a>
                </IconButton>
            </AppBar>
            <TabPanel value={value} index={0}>
                <RaceTable raceName={"2022_wintertrail"}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <RaceTable raceName={"2021_180k"}/>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <RaceTable raceName={"2021_100k"}/>
            </TabPanel>
            <TabPanel value={value} index={3}>
                <RaceTable raceName={"2021_50k"}/>
            </TabPanel>
            <TabPanel value={value} index={4}>
                <RaceTable raceName={"2020_180k"}/>
            </TabPanel>
            <TabPanel value={value} index={5}>
                <RaceTable raceName={"2020_100k"}/>
            </TabPanel>
            <TabPanel value={value} index={6}>
                <RaceTable raceName={"2020_40k"}/>
            </TabPanel>
        </Box>
    )
}
